import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, MenuProps, message } from 'antd';
import React from 'react';
import styled from 'styled-components';

interface LinkShortnerTableActionsProps {
  linkId: string;
  link: string;
  deleteLink: (id: string) => Promise<void>;
  editLink: () => void;
}

export const LinkShortnerTableActions: React.FC<LinkShortnerTableActionsProps> =
  ({ linkId, link, deleteLink, editLink }) => {
    const handleCopyLink = async () => {
      try {
        await navigator.clipboard.writeText(link);
        message.success('Link copiado para a área de transferência!');
      } catch (error) {
        message.error('Falha ao copiar o link.');
      }
    };

    const handleDeleteLink = async () => {
      try {
        await deleteLink(linkId);
      } catch (error) {
        message.error('Falha ao deletar o link.');
      }
    };

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleClick: MenuProps['onClick'] = e => {
      switch (e.key) {
        case 'COPY':
          handleCopyLink();
          break;
        case 'DELETE':
          handleDeleteLink();
          break;
        case 'EDIT':
          scrollToTop();
          editLink();
          break;
        default:
          break;
      }
    };

    const items: MenuProps['items'] = [
      {
        key: 'COPY',
        label: 'Copiar link',
        icon: <CopyOutlined />,
      },
      {
        key: 'EDIT',
        label: `Editar link`,
        icon: <EditOutlined />,
      },
      {
        key: 'DELETE',
        label: `Excluir link`,
        icon: <DeleteOutlined />,
      },
    ];

    return (
      <Dropdown
        placement='bottomRight'
        menu={{ items, onClick: handleClick }}
        trigger={['click']}
      >
        <CustomButton
          data-testid='link-menu-actions'
          style={{ border: 'none' }}
        >
          <MoreOutlined />
        </CustomButton>
      </Dropdown>
    );
  };

const CustomButton = styled(Button)`
  &:hover {
    background-color: rgba(62, 62, 62, 0.7);
    color: white;
  }
`;
